module.exports = __webpack_public_path__ + "assets/img/cathy.901cdf62.jpg";